<template>
    <div class="mt-15">
        <div v-if="bloqueo==0">
            <v-row>
                <v-col cols="12" class="mt-10 text-center">
                    <img src="@/assets/denegado.png" />
                </v-col>
            </v-row>
        </div>
        <div v-else-if="bloqueo==1">
            <v-container>
                <v-row class="mt-2">
                    <v-col cols="12" md="4">
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="4" md="4">
                                                <h5 class="mt-1">Caja Diaria</h5>
                                            </v-col>
                                            <v-col cols="8" md="8" class="text-end">
                                                <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">                                        
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip class="ml-2 text-button" @click="menu1 = true" v-bind="attrs" v-on="on" color="info">
                                                            <v-icon class="ml-2" small>events</v-icon>
                                                            {{date1}}
                                                        </v-chip>                                        
                                                    </template>
                                                <v-date-picker v-model="date1" @input="menu1 = false; serach_totales()" no-title scrollable></v-date-picker>
                                                </v-menu>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-sheet>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                                <div class="mt-n2" v-for="item in myTotales" :key="item.id" width="100%">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" md="12" style="background-color: lightgray; height: 10px; border-radius: 25px;">
                                                <h5 class="mt-n2">{{item.forma}}</h5>
                                            </v-col>
                                        </v-row>
                                        <v-divider class="mb-1"></v-divider>
                                        <v-row class="mt-n1">
                                            <v-col cols="3" md="3" class="text-center">
                                                <h6>Ventas</h6>
                                                <h5>${{ new Intl.NumberFormat("de-DE").format(parseFloat(item.total_servicio)) }}</h5>
                                            </v-col>
                                            <v-col cols="3" md="3" class="text-center">
                                                <h6>Ingreso</h6>
                                                <h5>${{ new Intl.NumberFormat("de-DE").format(parseFloat(item.total_ingreso)) }}</h5>
                                            </v-col>
                                            <v-col cols="3" md="3" class="text-center">
                                                <h6>Egreso</h6>
                                                <h5>${{ new Intl.NumberFormat("de-DE").format(parseFloat(item.total_egreso)) }}</h5>
                                            </v-col>
                                            <v-col cols="3" md="3" class="text-center">
                                                <h6>Total</h6>
                                                <h5>${{ new Intl.NumberFormat("de-DE").format(parseFloat(item.total)) }}</h5>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </div>
                                <div style="background-color: #c1680e; height: 45px; color:white; border-radius: 10px;">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="2" md="2">
                                                <v-btn @click="calcular_resumen()" class="mt-n2" fab x-small color="white"><v-icon color="#c1680e">print</v-icon></v-btn>
                                            </v-col>
                                            <v-col cols="5" md="5" class="text-end">
                                                <h3>TOTAL</h3>
                                            </v-col>
                                            <v-col cols="5" md="5" class="text-end">
                                                <h3>${{ new Intl.NumberFormat("de-DE").format(parseFloat(totales)) }}</h3>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="8">
                        <v-row>
                            <v-col cols="12" md="6">
                                <h5>Movimiento Manual</h5>
                                <v-radio-group v-model="radios">
                                    <template v-slot:label>
                                        <div>Seleccione la <strong>opción</strong> que corresponda</div>
                                    </template>
                                    <div style="background-color: #FEF2F2; height: 40px; border-radius: 10px;">
                                        <v-radio @click="radio_opcion(1)" class="mt-2 ml-5" value="opcion_01" color="red">
                                            <template v-slot:label>
                                            <div>Egresos <strong>Cta. Cte.</strong><v-icon class="ml-2" small color="error">call_made</v-icon></div>
                                            </template>
                                        </v-radio>
                                    </div>
                                    <div class="mt-1" style="background-color: #FEF2F2; height: 40px; border-radius: 10px;">
                                        <v-radio @click="radio_opcion(2)" class="mt-2 ml-5" value="opcion_02" color="red">
                                            <template v-slot:label>
                                            <div>Egresos <strong>Caja Chica</strong><v-icon class="ml-2" small color="error">call_made</v-icon></div>
                                            </template>
                                        </v-radio>
                                    </div>
                                    <div class="mt-1" style="background-color: #DFF2FE; height: 40px; border-radius: 10px;">
                                        <v-radio @click="radio_opcion(3)" class="mt-2 ml-5" value="opcion_03">
                                            <template v-slot:label>
                                                <div>Otros <strong>Ingresos</strong><v-icon class="ml-2" small color="success">call_received</v-icon></div>
                                            </template>
                                        </v-radio>
                                    </div>                                        
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12" md="6">
                                <div v-if="radios == 'opcion_01'">
                                    <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" md="5" class="d-flex">
                                                    <h5 class="mt-1">Egresos Cta. Cte.<v-icon class="ml-2" small color="error">call_made</v-icon></h5>
                                                </v-col>
                                                <v-col cols="12" md="7">
                                                    <v-select :items="myTipos" v-model="tp_cta_cte" style="background-color: beige; height: 30px;" class='text-body-2 black--text' dense rounded></v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row class="mt-10">
                                                <v-col cols="12" md="5" class="mt-n7">
                                                    <v-text-field type="number" label="Monto" class='text-body-2' v-model="monto_cta_cte" dense outlined rounded></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="7" class="mt-n7">
                                                    <v-select class='text-caption' v-model="forma_cta_cte" :items="myFormaPago" label="Forma de Pago" item-text="name" item-value="name" dense outlined rounded></v-select>
                                                </v-col>
                                                <v-col cols="10" md="10" class="mt-n7">
                                                    <v-text-field v-if="tp_cta_cte!='Anticipo'" label="Descripcion" class='text-body-2' v-model="txt_cta_cte" dense outlined rounded></v-text-field>
                                                    <v-select v-else class='text-body-2' v-model="profesional" :items="myProfesional" label="Profesional" dense outlined rounded></v-select>
                                            </v-col>
                                                <v-col cols="2" md="2" class="mt-n7">
                                                    <v-btn @click="save_output_cta_Cte()" small fab color="error" dark>
                                                        <v-icon>library_add</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-sheet>
                                </div>
                                <div v-if="radios == 'opcion_02'">
                                    <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" md="6" class="d-flex">
                                                    <h5 class="mt-1">Egresos Caja Chica<v-icon class="ml-2" small color="error">call_made</v-icon></h5>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-select placeholder="Gasto" style="background-color: lightgray; height: 30px;" class='text-body-2 black--text' v-model="tp_egreso" dense rounded readonly></v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row class="mt-10">
                                                <v-col cols="12" md="5" class="mt-n7">
                                                    <v-text-field type="number" label="Monto" class='text-body-2' v-model="monto_egreso" dense outlined rounded></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="7" class="mt-n7">
                                                    <v-select class='text-caption' v-model="forma_egreso" :items="myFormaPago" label="Forma de Pago" item-text="name" item-value="name" dense outlined rounded></v-select>
                                                </v-col>
                                                <v-col cols="10" md="10" class="mt-n7">
                                                    <v-text-field v-if="tp_egreso!='Anticipo'" label="Descripcion" class='text-body-2' v-model="txt_egreso" dense outlined rounded></v-text-field>
                                                    <v-select v-else class='text-body-2' v-model="profesional" :items="myProfesional" label="Profesional" dense outlined rounded></v-select>
                                                </v-col>
                                                <v-col cols="2" md="2" class="mt-n7">
                                                    <v-btn @click="save_output()" small fab color="error" dark>
                                                        <v-icon>library_add</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-sheet>
                                </div>
                                <div v-if="radios == 'opcion_03'">
                                    <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" md="5" class="d-flex">
                                                    <h5 class="mt-1">Ingresos<v-icon class="ml-2" small color="success">call_received</v-icon></h5>
                                                </v-col>
                                                <v-col cols="12" md="7">
                                                    <v-select placeholder="Ingreso" style="background-color: lightgray; height: 30px;" class='text-body-2 black--text' dense rounded readonly></v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row class="mt-10">
                                                <v-col cols="12" md="5" class="mt-n7">
                                                    <v-text-field type="number" label="Monto" class='text-body-2' v-model="monto_ingreso" dense outlined rounded></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="7" class="mt-n7">
                                                    <v-select class='text-caption' v-model="forma_ingreso" :items="myFormaPago" label="Forma de Pago" item-text="name" item-value="name" dense outlined rounded></v-select>
                                                </v-col>
                                                <v-col cols="10" md="10" class="mt-n7">
                                                    <v-text-field label="Descripcion" class='text-body-2' v-model="txt_ingreso" dense outlined rounded></v-text-field>
                                                </v-col>
                                                <v-col cols="2" md="2" class="mt-n7">
                                                    <v-btn @click="save_input()" small fab color="success" dark>
                                                        <v-icon>library_add</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-sheet>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n5">
                            <v-col cols="12" md="12">
                                <h5>Movimientos del Día</h5>
                                <v-simple-table fixed-header dense height="265" style="border:1px solid lightgray" class="text-size">
                                    <thead>
                                        <tr>
                                            <th style="background-color: lightgrey;width: 5%;">&nbsp;</th>
                                            <th style="background-color: lightgrey;width: 20%;">Servicio</th>
                                            <th style="background-color: lightgrey;width: 35%;">Detalle</th>
                                            <th style="background-color: lightgrey;width: 20%;">Profesional</th>
                                            <th style="background-color: lightgrey;width: 15%;">Total</th>
                                            <th style="background-color: lightgrey;width: 5%;">&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in myLista" :key="item.id">
                                            <td v-if="item.tipo=='servicio' || item.tipo=='ingreso'"><v-icon class="ml-2" small color="success">call_received</v-icon></td>
                                            <td v-if="item.tipo=='egreso' || item.tipo=='cta_cte'" ><v-icon class="ml-2" small color="error">call_made</v-icon></td>
                                            <td><span>{{ item.servicio.toUpperCase() }}</span></td>
                                            <td><span>{{ item.detalle }}</span></td>
                                            <td><span>{{ item.profesional }}</span></td>
                                            <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.total)) }}</span></td>
                                            <td v-if="item.tipo=='servicio'"><v-icon class="ml-2" small color="grey">not_interested</v-icon></td>
                                            <td v-else><v-icon class="ml-2" @click="eliminar_ie(item)" small color="error">delete</v-icon></td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div style="height: 50px;"></div>
        <v-footer height="50" color="#c1680e" fixed></v-footer>

        <img id="logo_solarium" src="@/assets/logo_solarium.jpg" height="0" width="0">             

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 20px !important;
    /* background-color: lightyellow; */
}
</style>
<script>
import axios from "axios";
import { jsPDF } from "jspdf";
export default {
    name: 'Caja',
    data: () => ({
        contrato:null,
        user:null,
        apikey:null,
        snack:false,
        color_snack:'',
        mensaje:'',
        bloqueo:null,
        loading:false,

        menu1:false,
        date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),

        myFormaPago:[],
        monto_ingreso:'',
        forma_ingreso:'',
        txt_ingreso:'',
        monto_egreso:'',
        forma_egreso:'',
        txt_egreso:'',
        myDetalle:[],
        myManual:[],
        myVentas:[],
        myLista:[],
        myTotales:[],
        totales:0,
        myTipos:['Gasto', 'Anticipo'],
        tp_cta_cte:'Gasto',
        tp_egreso:'Gasto',
        profesional:'',
        myProfesional:[],
        myEmisor:[],

        temp_ventas_salon:[],
        temp_formas_salon:[],
        temp_formas_solarium:[],
        temp_formas_productos:[],
        temp_otros_ingresos:[],
        temp_otros_egresos:[],
        temp_deposito:[],

        monto_cta_cte:'',
        txt_cta_cte:'',
        forma_cta_cte:'',

        radios:'opcion_01',

    }),
    async mounted(){
        const myToken = localStorage.getItem('mytoken');
        const myUser = localStorage.getItem('myuser');
        const myContrato = localStorage.getItem('mycontrato');
        const myTime = localStorage.getItem('timeuser');
        if(myToken!=null && myUser!=null && myContrato!=null){
        //verificamos la expiracion
        const ahora = new Date();
        const expira = new Date(myTime);
        if(ahora > expira){
            this.goLogin()
        } else {
            this.apikey = myToken;
            this.contrato = myContrato;
            this.user = myUser;
            this.loading=true;
            this.bloqueo = await this.myPermiso(3);
            if(parseInt(this.bloqueo)!=0){
                await this.search_formas();
                this.myLista=[];
                await this.search_atencion();
                await this.search_ventas();
                await this.search_manual();
                await this.calcular_caja();
                await this.search_users();
                //await this.search_emisor();
            }
            this.loading=false
        }
        } else {
            this.goLogin();
        }
    },
    methods:{
        radio_opcion(op){
            if(op==1){
                console.log('Haz seleccionado la opcion 1')
            }
            if(op==2){
                console.log('Haz seleccionado la opcion 2')
            }
            if(op==3){
                console.log('Haz seleccionado la opcion 3')
            }
        },
        clsInput(){
            this.monto_ingreso='';
            this.forma_ingreso='';
            this.txt_ingreso='';
            this.monto_egreso='';
            this.forma_egreso='';
            this.txt_egreso='';
            this.tp_egreso='Gasto'
            this.monto_cta_cte='';
            this.txt_cta_cte='';
            this.forma_cta_cte='';
        },
        goLogin(){
            localStorage.removeItem('mytoken');
            localStorage.removeItem('myuser');
            localStorage.removeItem('mycontrato');
            localStorage.removeItem('timeuser');
            this.$router.push({name:'Login'})
        },
        async myPermiso(id){
            let result = 0;
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id' : id
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    result = parseInt(datos[0].acceso);
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        async search_emisor(){
            this.myEmisor=[];
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/emisor/',params,{headers});
                const datos = res.data;
                console.log('emisor',datos);
                if(datos[0].existe=='si'){
                    var img = document.getElementById("logo_solarium");
                    img.src=datos[0].Logo;
                    this.myEmisor=datos;
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_users(){
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' :  this.user,
                    'usuario' :  'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/user/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        if(element.tipo=='Profesional'){
                            this.myProfesional.push(element.usuario)
                        }
                    })
                }
            } catch (error) {
                console.log(error);
            }
        },
        async serach_totales(){
            this.loading=true;
            this.myLista=[];
            await this.search_atencion();
            await this.search_ventas();
            await this.search_manual();
            await this.calcular_caja();
            this.loading=false 
        },
        async search_atencion(){
            this.myDetalle=[];
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'desde' : this.date1,
                    'hasta' : this.date1,
                    'profesional' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/get/atencion/',params,{headers});
                const datos = res.data;
                console.log('atencion',datos);
                if(datos[0].existe=='si'){
                    this.myDetalle=datos;
                    let myGlosa = "";
                    datos.forEach(element => {
                        if(element.Servicio!='SOLARIUM'){
                            myGlosa = "Salon"
                        } else {
                            myGlosa = "Solarium"
                        }
                        this.myLista.push({
                            id: element.ID,
                            servicio: element.Servicio,
                            detalle: element.Detalle,
                            profesional: element.Profesional,
                            total: element.Total_Servicio,
                            pago: element.Forma,
                            tipo:'servicio',
                            glosa: myGlosa
                        })
                    });
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_manual(){
            this.myManual=[];
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'desde' : this.date1,
                    'hasta' : this.date1,
                    'tipo' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/get/manual/',params,{headers});
                const datos = res.data;
                console.log('manual',datos);
                if(datos[0].existe=='si'){
                    this.myManual=datos;
                    let myGlosa = "";
                    datos.forEach(element => {
                        if(element.Servicio=='ingreso'){ myGlosa = "Ingreso" };
                        if(element.Servicio=='egreso'){ myGlosa = "Egreso" };
                        this.myLista.push({
                            id: element.ID,
                            servicio: element.Servicio,
                            detalle: element.Detalle,
                            profesional: element.Profesional,
                            total: element.Monto,
                            pago: element.Forma,
                            tipo: element.Servicio,
                            glosa: myGlosa
                        })
                    });
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_ventas(){
            this.myVentas=[];
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'desde' : this.date1,
                    'hasta' : this.date1,
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/report/ventas/',params,{headers});
                const datos = res.data;
                console.log('ventas',datos);
                if(datos[0].existe=='si'){
                    this.myVentas=datos;
                    datos.forEach(element => {
                        this.myLista.push({
                            id: element.ID,
                            servicio: 'Sku ' + element.Sku,
                            detalle: '('+ element.Cantidad +') ' + element.Producto,
                            profesional: element.Usuario,
                            total: element.Total,
                            pago: element.Forma,
                            tipo:'servicio',
                            glosa: 'Producto'
                        })
                    });
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_formas(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'forma' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/type/payments/',params,{headers});
                const datos = res.data;
                console.log('forma de pago',datos);
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.myFormaPago.push({
                            'name': element.Forma,
                            'comis': element.Comision
                        })
                    });
                }
            } catch (error) {
                console.log(error)
            }
        },
        async calcular_caja(){
            this.myTotales=[];
            this.totales=0;
            //recorrer las formas de pagos
            this.myFormaPago.forEach(element => {
                const forma = element.name;
                //filtramos todos los elementos de la forma
                const filter = this.myLista.filter(res => res.pago == forma);
                console.log('formas', filter);
                //sumar los totales de la forma de pago
                let sumaServicios = 0;
                let sumaIngresos = 0;
                let sumaEgresos = 0;
                let sumaTotales = 0;
                filter.forEach(element => {
                    if(element.tipo=='servicio'){
                        sumaServicios = parseFloat(sumaServicios) + parseFloat(element.total);
                    };
                    if(element.tipo=='ingreso'){
                        sumaIngresos = parseFloat(sumaIngresos) + parseFloat(element.total);
                    };
                    if(element.tipo=='egreso'){
                        sumaEgresos = parseFloat(sumaEgresos) + parseFloat(element.total);
                    };
                });
                sumaTotales = (parseFloat(sumaServicios) + parseFloat(sumaIngresos)) - parseFloat(sumaEgresos);                    
                // const sumaForma = filter.reduce((acumulador, objetoActual) => {
                //     return acumulador + objetoActual.total;
                // }, 0);
                this.myTotales.push({
                    forma: forma,
                    total_servicio: sumaServicios,
                    total_ingreso: sumaIngresos,
                    total_egreso: sumaEgresos,
                    total: sumaTotales,
                });
                this.totales=parseFloat(this.totales) + parseFloat(sumaTotales);
            });
            console.log(this.myTotales);
        },
        async save_input(){
            this.monto_ingreso = '' + this.monto_ingreso;
            if(this.monto_ingreso!=null && this.monto_ingreso!=''){
                try {
                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Token ' + this.apikey
                    };
                    const params = {
                        'contrato' : this.contrato,
                        'user' : this.user,
                        'fecha': this.date1,
                        'servicio': 'ingreso',
                        'detalle': this.txt_ingreso,
                        'profesional': this.user,
                        'forma' : this.forma_ingreso,
                        'monto': this.monto_ingreso
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/manual/',params,{headers});
                    const datos = res.data;
                    console.log(datos);
                    if(datos[0].existe=='si'){
                        await this.serach_totales();
                        this.clsInput();
                        this.color_snack='success';
                        this.mensaje='Ingreso manual con exito';
                        this.snack=true;
                    } else {
                        this.color_snack='error';
                        this.mensaje='Registro no ingresado';
                        this.snack=true
                    }
                } catch (error) {
                    console.log(error)
                    this.color_snack='error';
                    this.mensaje='Error, informar a soporte';
                    this.snack=true
                }   
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese monto valido';
                this.snack=true
            }
        },
        async save_output_cta_Cte(){
            this.monto_cta_cte = '' + this.monto_cta_cte;
            if(this.monto_cta_cte!=null && this.monto_cta_cte!=''){
                try {
                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Token ' + this.apikey
                    };
                    let params;
                    if(this.tp_cta_cte!='Anticipo'){
                        params = {
                            'contrato' : this.contrato,
                            'user' : this.user,
                            'fecha': this.date1,
                            'servicio': 'cta_cte',
                            'detalle': this.txt_cta_cte,
                            'profesional': this.user,
                            'forma' : this.forma_cta_cte,
                            'monto': this.monto_cta_cte
                        };
                    } else {
                        params = {
                            'contrato' : this.contrato,
                            'user' : this.user,
                            'fecha': this.date1,
                            'servicio': 'cta_cte',
                            'detalle': 'Anticipo',
                            'profesional': this.profesional,
                            'forma' : this.forma_cta_cte,
                            'monto': this.monto_cta_cte
                        };
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/manual/',params,{headers});
                    const datos = res.data;
                    if(datos[0].existe=='si'){
                        await this.serach_totales();
                        this.clsInput();
                        this.color_snack='success';
                        this.mensaje='Egreso manual con exito';
                        this.snack=true
                    } else {
                        this.color_snack='error';
                        this.mensaje='Registro no ingresado';
                        this.snack=true
                    }
                } catch (error) {
                    console.log(error)
                    this.color_snack='error';
                    this.mensaje='Error, informar a soporte';
                    this.snack=true
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese monto valido';
                this.snack=true
            }
        },
        async save_output(){
            this.monto_egreso = '' + this.monto_egreso;
            if(this.monto_egreso!=null && this.monto_egreso!=''){
                try {
                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Token ' + this.apikey
                    };
                    const params = {
                        'contrato' : this.contrato,
                        'user' : this.user,
                        'fecha': this.date1,
                        'servicio': 'egreso',
                        'detalle': this.txt_egreso,
                        'profesional': this.user,
                        'forma' : this.forma_egreso,
                        'monto': this.monto_egreso
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/manual/',params,{headers});
                    const datos = res.data;
                    if(datos[0].existe=='si'){
                        await this.serach_totales();
                        this.clsInput();
                        this.color_snack='success';
                        this.mensaje='Egreso manual con exito';
                        this.snack=true
                    } else {
                        this.color_snack='error';
                        this.mensaje='Registro no ingresado';
                        this.snack=true
                    }
                } catch (error) {
                    console.log(error)
                    this.color_snack='error';
                    this.mensaje='Error, informar a soporte';
                    this.snack=true
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese monto valido';
                this.snack=true
            }
        },
        async PDF_caja(){
            this.loading=true;

            const head_venta = this.myLista;
            console.log('data_PDF',head_venta)

            const doc = new jsPDF('p', 'mm', 'letter');

            var img_fondo = document.getElementById("logo_solarium");
            doc.addImage(img_fondo, 'JPEG', 15, 15, 75, 20)

            //grosor linea
            doc.setLineWidth(0.2);
            //horizontal lines
            doc.line(10, 10, 120, 10);
            doc.line(10, 40, 120, 40);
            //vertical lines
            doc.line(10, 9.5, 10, 40.5);
            doc.line(120, 9.5, 120, 40.5);

            doc.setFont("arial", "bold");
            doc.setFontSize(14);
            doc.text('FLUJO DE CAJA', 145, 15);

            doc.line(130, 30, 200, 30);
            doc.line(130, 40, 200, 40);
            //vertical lines
            doc.line(130, 30.5, 130, 40.5);
            doc.line(200, 30.5, 200, 40.5);

            doc.setFont("arial", "bold");
            doc.setFontSize(10);
            doc.text('FECHA : ', 135, 36);
            doc.setFontSize(12);
            doc.text('' + this.date1, 170, 36);


            //obtener datos del usuario
            doc.setFontSize(8);
            let line = 45;
            doc.line(10, line, 200, line);
            line = line + 5;
            doc.text('TOTALES', 15, line);
            this.myTotales.forEach(element => {
                line = line + 5;
                doc.setFont("arial", "bold");
                doc.text('' + element.forma, 15, line);
                doc.setFont("arial", "normal");
                doc.text('Venta : $ ' + new Intl.NumberFormat("de-DE").format(parseFloat(element.total_servicio)), 45, line);
                doc.text('Ingreso : $ ' + new Intl.NumberFormat("de-DE").format(parseFloat(element.total_ingreso)), 75, line);
                doc.text('Egreso : $ ' + new Intl.NumberFormat("de-DE").format(parseFloat(element.total_egreso)), 105, line);
                doc.text('Total : $ ' + new Intl.NumberFormat("de-DE").format(parseFloat(element.total)), 135, line);
            });
            line = line + 5;
            doc.line(10, line, 200, line);

            line = line + 3.5;
            doc.setFont("arial", "bold");
            doc.text('SERVICIO', 10, line);
            doc.text('DETALLE', 30, line);
            doc.text('PROFESIONAL', 135, line);
            doc.text('TOTAL', 170, line, { align: "right" });
            doc.text('I/E', 190, line);
            
            line = line + 1.5;
            doc.line(10, line, 200, line);
            
            //Detalle
            line = line + 5;
            doc.setFont("arial", "normal");
            this.myLista.forEach(element => {
                doc.text('' + element.servicio, 10, line);
                doc.text('' + element.detalle, 30, line);
                doc.text('' + element.profesional, 135, line);
                doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.total)), 170, line, { align: "right" });
                doc.text('' + element.tipo, 190, line);                            
                line = line + 5;
            });
           
            doc.output('dataurlnewwindow')
            this.loading=false;
        },
        async calcular_resumen(){
            this.temp_ventas_salon=[];
            this.temp_formas_salon=[];
            this.temp_formas_solarium=[];
            this.temp_formas_productos=[];
            this.temp_otros_ingresos=[];
            this.temp_otros_egresos=[];
            this.temp_deposito=[];
            if(this.myLista.length!=0){
                console.log('myLista', this.myLista);
                this.myLista.forEach(element => {
                    const key = element.glosa;
                    switch (key) {
                        case "Salon": // Salon
                            //sumar totales x profesional
                            if(this.temp_ventas_salon.length!=0){
                                const found = this.temp_ventas_salon.filter(res => res.profesional == element.profesional);
                                if(found.length!=0){
                                    const myMonto = parseFloat(found[0].monto) + parseFloat(element.total);
                                    found[0].monto = myMonto; 
                                } else {
                                    this.temp_ventas_salon.push({
                                        "profesional": element.profesional,
                                        "monto": element.total,
                                    });
                                }
                            } else {
                                this.temp_ventas_salon.push({
                                    "profesional": element.profesional,
                                    "monto": element.total,
                                });
                            };
                            //totales acumulados
                            if(this.temp_formas_salon.length!=0){
                                const found = this.temp_formas_salon.filter(res => res.forma == element.pago);
                                if(found.length!=0){
                                    const myMonto = parseFloat(found[0].monto) + parseFloat(element.total);
                                    found[0].monto = myMonto; 
                                } else {
                                    this.temp_formas_salon.push({
                                        "forma": element.pago,
                                        "monto": element.total
                                    })
                                }
                            } else {
                                this.temp_formas_salon.push({
                                    "forma": element.pago,
                                    "monto": element.total
                                })
                            };
                            //agregar el efectivo para deposito
                            if(element.pago=='Efectivo'){
                                this.temp_deposito.push({
                                    "glosa": element.glosa,
                                    "monto": element.total
                                })
                            }                           
                        break;
                        case "Solarium": // Solarium
                            //totales acumulados
                            if(this.temp_formas_solarium.length!=0){
                                const found = this.temp_formas_solarium.filter(res => res.forma == element.pago);
                                if(found.length!=0){
                                    const myMonto = parseFloat(found[0].monto) + parseFloat(element.total);
                                    found[0].monto = myMonto; 
                                } else {
                                    this.temp_formas_solarium.push({
                                        "forma": element.pago,
                                        "monto": element.total
                                    })
                                }
                            } else {
                                this.temp_formas_solarium.push({
                                    "forma": element.pago,
                                    "monto": element.total
                                })
                            };
                            //agregar el efectivo para deposito
                            if(element.pago=='Efectivo'){
                                this.temp_deposito.push({
                                    "glosa": element.glosa,
                                    "monto": element.total
                                })
                            }                           
                        break;
                        case "Producto": // Producto
                            //totales acumulados
                            if(this.temp_formas_productos.length!=0){
                                const found = this.temp_formas_productos.filter(res => res.forma == element.pago);
                                if(found.length!=0){
                                    const myMonto = parseFloat(found[0].monto) + parseFloat(element.total);
                                    found[0].monto = myMonto; 
                                } else {
                                    this.temp_formas_productos.push({
                                        "forma": element.pago,
                                        "monto": element.total
                                    })
                                }
                            } else {
                                this.temp_formas_productos.push({
                                    "forma": element.pago,
                                    "monto": element.total
                                })
                            };
                            //agregar el efectivo para deposito
                            if(element.pago=='Efectivo'){
                                this.temp_deposito.push({
                                    "glosa": element.glosa,
                                    "monto": element.total
                                })
                            }                           
                        break;
                        case "Ingreso": // otros ingresos
                            //detalle ingreso
                            this.temp_otros_ingresos.push({
                                "ingreso": element.detalle,
                                "monto": element.total
                            });
                            //agregar el efectivo para deposito
                            if(element.pago=='Efectivo'){
                                this.temp_deposito.push({
                                    "glosa": element.glosa,
                                    "monto": element.total
                                })
                            }                           
                        break;
                        case "Egreso": // otros egresos
                            //detalle egreso
                            this.temp_otros_egresos.push({
                                "egreso": element.detalle,
                                "monto": element.total
                            });
                            //agregar el efectivo para deposito
                            if(element.pago=='Efectivo'){
                                this.temp_deposito.push({
                                    "glosa": element.glosa,
                                    "monto": element.total
                                })
                            }                           
                        break;
                    }
                });
                this.PDF_resumen();
            } else {
                console.log('sin registros en la lista')
            };
        },

        async PDF_resumen(){
            this.loading=true;

            const head_venta = this.myLista;
            console.log('data_PDF',head_venta)

            const doc = new jsPDF('p', 'mm', 'letter');

            var img_fondo = document.getElementById("logo_solarium");
            doc.addImage(img_fondo, 'JPEG', 15, 15, 75, 20)

            //grosor linea
            doc.setLineWidth(0.2);
            //horizontal lines
            doc.line(10, 10, 120, 10);
            doc.line(10, 40, 120, 40);
            //vertical lines
            doc.line(10, 9.5, 10, 40.5);
            doc.line(120, 9.5, 120, 40.5);

            doc.setFont("arial", "bold");
            doc.setFontSize(14);
            doc.text('FLUJO DE CAJA', 145, 15);

            doc.line(130, 20, 200, 20);
            doc.line(130, 30, 200, 30);
            //vertical lines
            doc.line(130, 20.5, 130, 30.5);
            doc.line(200, 20.5, 200, 30.5);

            doc.setFont("arial", "bold");
            doc.setFontSize(10);
            doc.text('FECHA : ', 135, 26);
            doc.setFontSize(12);
            doc.text('' + this.date1, 170, 26);



            doc.setFontSize(10);
            //lista de profesionales
            doc.setFillColor(224, 255, 255);
            doc.rect(8, 45, 98, 7, 'F'); 
            doc.text('PROFESIONAL', 20, 50);
            doc.text('MONTO', 85, 50);
            let line = 52;
            let total_profesionales = 0;
            this.temp_ventas_salon.forEach(element => {
                line = line + 5;
                doc.text('' + element.profesional, 20, line);
                doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(element.monto)), 102, line, { align: "right" });
                total_profesionales = parseFloat(total_profesionales) + parseFloat(element.monto);
            });
            //otros ingresos
            let total_ingresos = 0;
            line = line + 20
            doc.text('OTROS INGRESOS', 20, line);
            line = line + 2
            doc.setFillColor(224, 255, 255);
            doc.rect(8, line, 98, 7, 'F'); 
            line = line + 5
            doc.text('ITEM', 20, line);
            doc.text('MONTO', 85, line);
            line = line + 2
            this.temp_otros_ingresos.forEach(element => {
                line = line + 5
                doc.text('' + element.ingreso, 20, line);
                doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(element.monto)), 102, line, { align: "right" });
                total_ingresos = parseFloat(total_ingresos) + parseFloat(element.monto);
            });
            line = line + 2
            doc.setFillColor(235, 243, 231);
            doc.rect(8, line, 98, 7, 'F'); 
            line = line + 5
            doc.text('TOTAL OTROS INGRESOS', 20, line);
            doc.text('$ '+ new Intl.NumberFormat("de-DE").format(parseFloat(total_ingresos)), 102, line, { align: "right" });
            line = line + 2

            //total salon
            let total_salon = 0;
            line = 45
            doc.setFillColor(224, 255, 255);
            doc.rect(118, line, 90, 7, 'F'); 
            line = line + 5;
            doc.text('VENTA SALON', 150, line);
            line = line + 2;
            this.temp_formas_salon.forEach(element => {
                line = line + 5
                doc.text(''+ element.forma, 120, line);
                doc.text('$ '+ new Intl.NumberFormat("de-DE").format(parseFloat(element.monto)), 205, line, { align: "right" });
                total_salon = parseFloat(total_salon) + parseFloat(element.monto);
            });
            line = line + 2
            doc.setFillColor(235, 243, 231);
            doc.rect(118, line, 90, 7, 'F'); 
            line = line + 5
            doc.text('SUMA TOTAL SALON', 120, line);
            doc.text('$ '+ new Intl.NumberFormat("de-DE").format(parseFloat(total_salon)), 205, line, { align: "right" });
            line = line + 2

            //total solarium
            let total_solarium = 0;
            line = line + 10
            doc.setFillColor(224, 255, 255);
            doc.rect(118, line, 90, 7, 'F'); 
            line = line + 5;
            doc.text('VENTA SOLARIUM', 150, line);
            line = line + 2;
            this.temp_formas_solarium.forEach(element => {
                line = line + 5;
                doc.text('' + element.forma, 120, line);
                doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(element.monto)), 205, line, { align: "right" });
                total_solarium = parseFloat(total_solarium) + parseFloat(element.monto);
            });
            line = line + 2
            doc.setFillColor(235, 243, 231);
            doc.rect(118, line, 90, 7, 'F'); 
            line = line + 5
            doc.text('SUMA TOTAL SOLARIUM', 120, line);
            doc.text('$ '+ new Intl.NumberFormat("de-DE").format(parseFloat(total_solarium)), 205, line, { align: "right" });
            line = line + 2

            //total productos
            let total_productos = 0;
            line = line + 10
            doc.setFillColor(224, 255, 255);
            doc.rect(118, line, 90, 7, 'F'); 
            line = line + 5;
            doc.text('VENTA PRODUCTOS', 150, line);
            line = line + 2;
            this.temp_formas_productos.forEach(element => {
                line = line + 5;
                doc.text('' + element.forma, 120, line);
                doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(element.monto)), 205, line, { align: "right" });
                total_productos = parseFloat(total_productos) + parseFloat(element.monto);
            });
            line = line + 2
            doc.setFillColor(235, 243, 231);
            doc.rect(118, line, 90, 7, 'F'); 
            line = line + 5
            doc.text('SUMA TOTAL PRODUCTOS', 120, line);
            doc.text('$ '+ new Intl.NumberFormat("de-DE").format(parseFloat(total_productos)), 205, line, { align: "right" });
            line = line + 2
            
            //gastos
            let total_egresos = 0;
            line = line + 10
            doc.text('GASTOS', 120, line);
            line = line + 2
            doc.setFillColor(224, 255, 255);
            doc.rect(118, line, 90, 7, 'F'); 
            line = line + 5
            doc.text('ITEM', 120, line);
            doc.text('MONTO', 190, line);
            line = line + 2
            this.temp_otros_egresos.forEach(element => {
                line = line + 5
                doc.text('' + element.egreso, 120, line);
                doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(element.monto)), 205, line, { align: "right" });                
                total_egresos = parseFloat(total_egresos) + parseFloat(element.monto);
            });
            line = line + 2
            doc.setFillColor(235, 243, 231);
            doc.rect(118, line, 90, 7, 'F'); 
            line = line + 5
            doc.text('SUMA TOTAL GASTOS', 120, line);
            doc.text('$ '+ new Intl.NumberFormat("de-DE").format(parseFloat(total_egresos)), 205, line, { align: "right" });
            line = line + 2

            //deposito
            let deposito_salon=0;
            let deposito_solarium=0;
            let deposito_ventas=0;
            let deposito_ingreso=0;
            let deposito_egreso=0;
            this.temp_deposito.forEach(element => {
                const key=element.glosa;
                switch (key) {
                    case 'Salon':
                        deposito_salon = parseFloat(deposito_salon) + parseFloat(element.monto); 
                    break;
                    case 'Solarium':
                        deposito_solarium = parseFloat(deposito_solarium) + parseFloat(element.monto); 
                    break;
                    case 'Producto':
                        deposito_ventas = parseFloat(deposito_ventas) + parseFloat(element.monto); 
                    break;
                    case 'Ingreso':
                        deposito_ingreso = parseFloat(deposito_ingreso) + parseFloat(element.monto); 
                    break;
                    case 'Egreso':
                        deposito_egreso = parseFloat(deposito_egreso) + parseFloat(element.monto); 
                    break;
                }
            });
            doc.line(10, 180, 100, 180);
            doc.setFillColor(224, 255, 255);
            doc.rect(8, 180, 98, 7, 'F'); 
            doc.text('DEPÓSITO - EFECTIVO', 35, 185);
            doc.text('Salon', 20, 192);
            doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(deposito_salon)), 102, 192, { align: "right" });
            doc.text('Solarium', 20, 197);
            doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(deposito_solarium)), 102, 197, { align: "right" });
            doc.text('Productos', 20, 202);
            doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(deposito_ventas)), 102, 202, { align: "right" });
            doc.text('Otros Ingresos', 20, 207);
            doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(deposito_ingreso)), 102, 207, { align: "right" });
            doc.text('Gastos', 20, 212);
            doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(deposito_egreso)), 102, 212, { align: "right" });
            const Ttt_ingresos = parseFloat(deposito_salon) + parseFloat(deposito_solarium) + parseFloat(deposito_ventas) + parseFloat(deposito_ingreso); 
            const Ttt_gastos =  parseFloat(deposito_egreso);
            const Ttotal_total = parseFloat(Ttt_ingresos) - parseFloat(Ttt_gastos);
            doc.setFillColor(235, 243, 231);
            doc.rect(8, 215, 98, 7, 'F'); 
            doc.text('TOTAL EFECTIVO - GASTOS', 20, 220);
            doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(Ttotal_total)), 102, 220, { align: "right" });

            //totales
            doc.line(10, 230, 100, 230);
            doc.setFillColor(224, 255, 255);
            doc.rect(8, 230, 98, 7, 'F'); 
            doc.text('RESUMEN CAJA', 35, 235);
            doc.text('Salon', 20, 242);
            doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(total_salon)), 102, 242, { align: "right" });
            doc.text('Solarium', 20, 247);
            doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(total_solarium)), 102, 247, { align: "right" });
            doc.text('Productos', 20, 252);
            doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(total_productos)), 102, 252, { align: "right" });
            doc.text('Otros Ingresos', 20, 257);
            doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(total_ingresos)), 102, 257, { align: "right" });
            doc.text('Gastos', 20, 262);
            doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(total_egresos)), 102, 262, { align: "right" });
            const tt_ingresos = parseFloat(total_salon) + parseFloat(total_solarium) + parseFloat(total_productos) + parseFloat(total_ingresos); 
            const tt_gastos =  parseFloat(total_egresos);
            const total_total = parseFloat(tt_ingresos) - parseFloat(tt_gastos);
            doc.setFillColor(235, 243, 231);
            doc.rect(8, 265, 98, 7, 'F'); 
            doc.text('TOTAL DIA', 20, 270);
            doc.text('$ ' + new Intl.NumberFormat("de-DE").format(parseFloat(total_total)), 102, 270, { align: "right" });


            doc.output('dataurlnewwindow')
            this.loading=false;
        },
        async eliminar_ie(item){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id' : item.id
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/delete/manual/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    await this.serach_totales();
                    this.clsInput();
                }                                
            } catch (error) {
                console.log(error)
            }
        }

    }
}
</script>